import * as Yup from "yup";

export const delegationInviteValidationSchema = Yup.object({
  invitedName: Yup.string()
    .trim()
    .required("Modtagerens navn er påkrævet")
    .max(200, "Maks. 200 tegn"),
  invitedLabel: Yup.string().trim().max(200, "Maks. 200 tegn"),
  deliveryEmail: Yup.string()
    .trim()
    .required("E-mail er påkrævet")
    .email("Ugyldig e-mailadresse"),
  permissions: Yup.number()
    .min(1, "Vælg mindst én rettighed")
    .required("Vælg mindst én rettighed"),
  expiryDays: Yup.number()
    .integer("Skal være et helt tal")
    .min(1, "Mindst 1 dag")
    .max(90, "Højst 90 dage")
    .required("Angiv udløb"),
  hasDelegationExpiry: Yup.boolean().required(),
  delegationValidDays: Yup.number().when("hasDelegationExpiry", {
    is: true,
    then: (schema) =>
      schema
        .integer("Skal være et helt tal")
        .min(1, "Mindst 1 dag")
        .max(1095, "Højst 1095 dage")
        .required("Angiv varighed"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
